import wixLocation from "wix-location";
import wixWindow from "wix-window";
import { getLoggedInUser } from "public/users.js";
import { suggest } from "backend/suggest.jsw";
import {
    TLD_NOT_SUPPORTED,
    validateDomain,
    SHORT_DOMAIN,
    LONG_DOMAIN,
    NOT_VALID,
    getTldForPurchase,
    // prices,
} from "public/validate-domain.js";

import { fireBIEvent } from 'public/bi-events.js';

let loadMore = 5;
let repeaterData = [];
let startTimeView;

$w.onReady(function () {
    pageEvents();
});

function pageEvents() {
    const domainParameter = wixLocation.query["domainName"];
    const domainQuery = wixLocation.query["Truic_LLC"];
    if (domainParameter) {
        $w("#mainSearchInput").value = domainParameter;
        setTimeout(() => {
            searchForDomain(domainParameter);
        }, 600);
    }
    if (domainQuery) {
        $w("#mainSearchInput").value = domainQuery;
        setTimeout(() => {
            searchForDomain(domainQuery);
        }, 600);
    }
    if (wixWindow.formFactor === "Desktop") {
        stickyHeaderEvents();
    }
    $w("#onlinePresenceTitle").onViewportEnter(() => {
        $w("#onlinePresenceDataset").loadMore();
    });
    $w('#onlinePresenceDataset').onReady(() => {
        $w("#repeater1").forEachItem(($item, itemData, index) => {
            let richText = itemData.description
            let replaceLineHightP = richText.replace(/<p class="font_9">/g, `<p class="p3" style="line-height: 1.6em; font-size: 16px;">`);
            $item("#textDescription").html = replaceLineHightP
        });
    })
    hideResults();
    inputDomainEvents();
    resultRepeaterEvents();
}

function inputDomainEvents() {
    $w("#mainSearchInput").focus();
    $w("#mainSearchInput").onKeyPress(({ key = "" }) => {
        hideResults();
        if (wixWindow.formFactor !== "Desktop") {
            $w("#repeaterMsg").collapse();
            $w("#disclamer").show();
        }
        $w("#xIcon").show();
        validateInput(key);
    });

    $w("#xIcon").onClick(() => {
        hideResults();
        $w("#mainSearchInput").value = "";
        $w("#stickySearchInput").value = "";
    });
    $w("#greenXIcon").onClick(() => {
        hideResults();
        $w("#mainSearchInput").value = "";
        $w("#stickySearchInput").value = "";
        $w("#greenXIcon").hide();
    });
    $w("#searchDomain").onClick(() => {
        setTimeout(() => {
            searchForDomain($w("#mainSearchInput").value);
        }, 600);
    });
}

async function resultRepeaterEvents() {
    let skipped;
    $w("#suggestionsrepeater").onItemReady(($item, itemData, index) => {
        startTimeView = new Date();
        if (itemData.domain !== $w("#mainSearchInput").value.replace("www.", "")) {
            $item("#domainSuggestion").text = itemData.domain;
            // $item("#domainPrice").text = `from $${itemData.price}/year`;
            $w("#suggestionsrepeater").expand();
            if (index === 0 || index === skipped) {
                $item("#getIt").show();
                $item("#recomended").show();
                $item("#hoverBox").style.backgroundColor = "#F2F4F5";
            }
            $item("#repeaterItem").onMouseIn(async () => {
                $w("#suggestionsrepeater").forEachItem(
                    ($Otheritem, OtheritemData, Otherindex) => {
                        if (index !== Otherindex) {
                            $Otheritem("#hoverBox").style.backgroundColor = "#FFFFFF";
                            $Otheritem("#getIt").hide();
                        }
                    }
                );
                $item("#hoverBox").style.backgroundColor = "#F2F4F5";
                $item("#getIt").show();
            });
            $item("#repeaterItem").onMouseOut(async () => {
                $item("#hoverBox").style.backgroundColor = "#FFFFFF";
                $item("#getIt").hide();
            });
            $item("#getDomainBtn").onClick(() => {
                getDomain({
                    // price: itemData.price,
                    domainName: itemData.domain,
                    position: index + 1,
                    type: "suggestions",
                });
            });
            $item("#getIt").onClick(() => {
                getDomain({
                    // price: itemData.price,
                    domainName: itemData.domain,
                    position: index + 1,
                    type: "suggestions",
                });
            });
            if (index >= loadMore) {
                $w("#loadMore").expand();
                $item("#repeaterItem").collapse();
            }
        } else {
            if (index === 0) {
                skipped = 1;
                loadMore = 6;
            }
            $item("#repeaterItem").collapse();
        }
    });

    $w("#loadMore").onClick(() => {
        loadMore += 5;
        let data = repeaterData;
        $w("#suggestionsrepeater").data = data.slice(0, loadMore);
        let result = data.slice(loadMore - 5, loadMore);
        $w("#suggestionsrepeater").forEachItem(($item, itemData, index) => {
            if (index < loadMore) {
                $item("#repeaterItem").expand();
            }
        });
        if (loadMore >= repeaterData.length) {
            $w("#loadMore").collapse();
        }
        fireBIEvent(953, {
            result: JSON.stringify(result),
            searchTerm: $w("#mainSearchInput").value
        })
    });
}

async function stickyHeaderEvents() {
    $w("#stickyHeaderAnchor").onViewportLeave(() => {
        $w("#stickyHeader").show();
    });
    $w("#stickyHeaderAnchor").onViewportEnter(() => {
        $w("#stickyHeader").hide();
    });
    $w("#stickySearchInput").onKeyPress(async (e) => {
        if (e.key === "Enter") {
            $w("#mainSearchInput").value = $w("#stickySearchInput").value;
            $w("#stickySearchInput").value = "";
            $w("#stickyHeader").hide();
            await validateInput();
            setTimeout(() => {
                searchForDomain($w("#mainSearchInput").value);
            }, 600);
            $w("#columnStrip4").scrollTo();
        }
    });

    $w("#stickySearchInput").onFocus(() => {
        hideResults();
    });
    $w("#headerSearch").onClick(async () => {
        $w("#mainSearchInput").value = $w("#stickySearchInput").value;
        $w("#stickySearchInput").value = "";
        $w("#stickyHeader").hide();
        await validateInput();
        setTimeout(() => {
            searchForDomain($w("#stickySearchInput").value);
        }, 600);
        $w("#columnStrip4").scrollTo();
    });
}

function validateInput(key) {
    setTimeout(() => {
        const inputDomain = $w("#mainSearchInput").value;
        switch (true) {
        case !inputDomain:
            //to-do ?show user error message saying invalid domain name
            hideResults();
            $w("#preloader").hide(); //addition
            break;
        case inputDomain === "www.":
            $w("#mainSearchInput").value = "";
            break;
        case key.match(/^([-a-zA-Z0-9\.]+)$/) === null:
            $w("#mainSearchInput").value = inputDomain.replace(`${key}`, "");
            $w("#errorText").text =
                "Enter letters, numbers, periods and hyphens only.";
            $w("#errorText").expand();
            $w("#disclamer").hide();
            break;
        case key.match(/^[A-Z ]+$/) !== null:
            $w("#mainSearchInput").value = inputDomain.toLocaleLowerCase();
            break;
        case key === "Enter":
            setTimeout(() => {
                searchForDomain(inputDomain);
            }, 600);
            break;
        default:
            break;
        }
    }, 500);
}

function validateInputDomain(inputDomain) {
    let isInputDomainValid = true;
    switch (true) {
    case !inputDomain:
        $w("#preloader").hide();
        isInputDomainValid = false;
        break;
    case inputDomain.length < 3 || inputDomain.startsWith("."):
        $w("#preloader").hide();
        $w("#errorText").text =
            "Type a domain that includes at least 3 characters.";
        $w("#mainSearchInput").focus();
        $w("#errorText").expand();
        $w("#disclamer").hide();
        isInputDomainValid = false;
        break;
    case inputDomain.split(".").length - 1 > 1 &&
    !inputDomain.endsWith(".co.uk") &&
    !inputDomain.endsWith(".com.br"):
        $w("#preloader").hide();
        $w("#errorText").text = "Subdomains are not available.";
        $w("#mainSearchInput").focus();
        $w("#errorText").expand();
        $w("#disclamer").hide();
        isInputDomainValid = false;
        break;

    }
    return isInputDomainValid;
}

async function searchForDomain(inputDomain) {
    let startTime, endTime, type, seconds;
    startTime = new Date();

    hideResults();
    $w("#disclamer").hide();
    repeaterData = [];
    $w("#repeaterMsg").collapse();
    $w("#preloader").show();
    $w("#suggestionsrepeater").data = [];

    if (!inputDomain.includes(".")) {
        inputDomain = inputDomain + ".com";
        $w("#mainSearchInput").value = inputDomain;
    }
    fireBIEvent(950, { text: inputDomain });
    const isInputDomainValid = validateInputDomain(inputDomain);
    if (!isInputDomainValid) {
        return;
    }
    if (inputDomain.match(/^([-a-zA-Z0-9\.]+)$/) === null) {
        // this case updates searched domain
        inputDomain = await lookForTld(inputDomain);
    }
    // if (!$w('#errorText').collapsed) {
    //     $w('#preloader').hide();
    //     return;
    // } to check ??
    $w("#errorText").collapse();
    try {
        const sanitizedDomain = validateDomain(`${inputDomain}`);
        let suggestResult = await suggest(sanitizedDomain);
        console.log(suggestResult,"here suggest result")
        const { suggestions = [], code = '' } = suggestResult || {};
        if (!suggestions) {
            console.log(code, 'timeout error');
            $w('#errorText').text='It looks like something happened on our end. Try again.';
            $w('#errorText').expand();
            return;
        }
        const isDoaminAvailabile = isDomainAvailabile(suggestions, inputDomain);
        if (isDoaminAvailabile) {
            const endTime = new Date();
            const timeDiff = endTime - startTime; //in ms
            fireBIEvent(951, {
                responseSpeed: timeDiff,
                result: inputDomain,
                searchTerm: inputDomain,
                type: 'Availabile'
            })
            return;
        }
        let updatedDomain;
        if (suggestions.length > 0) {
            const suggestionsWithIds = suggestions.map((item, index) => {
                const { domain = "" } = item || {};
                if (domain.split(".").length > 2) {
                    updatedDomain = `${domain.split(".")[1]}.${domain.split(".")[2]}`;
                } else {
                    updatedDomain = domain.split(".")[1];
                }
                // let priceOfDomain = prices[updatedDomain];
                // item.price = priceOfDomain;
                item._id = index.toString();
                return item;
            });
            repeaterData = suggestionsWithIds;

            $w("#preloader").hide();
            $w("#suggestionsrepeater").data = [];
            $w("#suggestionsrepeater").data = await suggestionsWithIds.slice(0, 6);
            $w("#repeaterMsg").text =
                inputDomain + " is taken. Choose one of the great options below.";
            $w("#repeaterMsg").expand();
            $w("#xIcon").show();
            endTime = new Date();
            let timeDiff = endTime - startTime; //in ms
            fireBIEvent(951, {
                responseSpeed: timeDiff,
                result: JSON.stringify($w('#suggestionsrepeater').data),
                searchTerm: inputDomain,
                type: 'suggestions'
            })
        } else {
            $w("#repeaterMsg").text =
                inputDomain + " isn’t available. Search for another domain name.";
            $w("#repeaterMsg").expand();
            $w("#xIcon").show();
            $w("#preloader").hide();
        }
    } catch (err) {
        console.error("caught error: ", err);
        $w("#preloader").hide();
        checkSearchError(inputDomain, err);
        endTime = new Date();
        const timeDiff = endTime - startTime; //in ms
        fireBIEvent(951, {
            responseSpeed: timeDiff,
            result: err,
            searchTerm: inputDomain,
            type: 'error'
        })
        return;
    }
}

async function checkSearchError(inputDomain, { message = "" }) {
    let errorMessage = "";
    switch (message) {
    case TLD_NOT_SUPPORTED:
        $w(
            "#repeaterMsg"
        ).text = `We currently don't register ${inputDomain.slice(inputDomain.indexOf("."))} domains. Choose any of the options below.`;
        errorMessage = `We currently don't register ${inputDomain.slice(inputDomain.indexOf("."))} domains. Choose any of the options below.`;
        $w("#repeaterMsg").expand();
        await removeTLD(inputDomain);
        break;

    case SHORT_DOMAIN: {
        $w("#errorText").text =
            "Type a domain that includes at least 3 characters.";
        errorMessage = "Type a domain that includes at least 3 characters.";
        $w("#errorText").expand();
        $w("#disclamer").hide();
        break;
    }
    case LONG_DOMAIN:
        $w("#errorText").text =
            "Type a domain that includes no more than 63 characters.";
        errorMessage = "Type a domain that includes no more than 63 characters.";
        $w("#errorText").expand();
        $w("#disclamer").hide();
        break;

    case NOT_VALID:
        $w("#errorText").text =
            "Enter letters, numbers, periods and hyphens only.";
        errorMessage = "Enter letters, numbers, periods and hyphens only.";
        $w("#errorText").expand();
        $w("#disclamer").hide();
        break;
    }
}
async function getDomain(props) {
    const { price='', domainName = '', position, type } = props;
    let endTime = new Date();
    let seconds = endTime - startTimeView; //in ms
    //add here
    fireBIEvent(952, {
        responseSpeed: seconds,
        domain: domainName,
        searchTerm: $w('#mainSearchInput').value,
        type: type,
        position: position
    })
    let voucherTld = await voucherIncluded(domainName);

    if (voucherTld) {
        // previous link with price included
        //`https://www.wix.com/wearepages/lior-blank?domain=${domainName}&price=${price}`
        wixLocation.to(
            `https://www.wix.com/wearepages/lior-blank?domain=${domainName}`
        );
    } else {
        const success = await getLoggedInUser();
        let loggenInlink = `https://apps.wix.com/redirect-post-domain/?inputDomain=${domainName}&referralAdditionalInfo=Anonymous-search`;
        let anonymousLink = `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://apps.wix.com/redirect-post-domain/?domainName=${domainName}%26referralAdditionalInfo=Sign-in&referralUrl=https:%2F%2Fwww.wix.com%2Fdomain%2Fnames%3Fexperiments%3DrightClickDebug`;
        if (success) {
            wixLocation.to(loggenInlink);
        } else {
            wixLocation.to(anonymousLink);
        }
    }
}

async function removeTLD(domain) {
    let sanitizedDomain = domain.slice(0, domain.indexOf("."));
    let res = await suggest(sanitizedDomain);
    const withIds = res.suggestions.map((item, index) => {
        if (item.domain.split(".").length > 2) {
            domain = `${item.domain.split(".")[1]}.${item.domain.split(".")[2]}`;
        } else {
            domain = item.domain.split(".")[1];
        }
        // let priceOfDomain = prices[domain];
        // item.price = priceOfDomain;
        item._id = index.toString();
        return item;
    });
    $w("#suggestionsrepeater").data = [];
    $w("#suggestionsrepeater").data = withIds;
}

async function lookForTld(inputDomain) {
    let finalDomain;
    let tlds = getTldForPurchase();

    if (tlds.includes(inputDomain)) {
        return false;
    }
    const newDomain = tlds.find((tld) => {
        const tldIndex = inputDomain.indexOf(tld);
        if (
            tldIndex !== -1 &&
            inputDomain[tldIndex - 1].match(/^([-a-zA-Z0-9\.]+)$/) === null
        ) {
            finalDomain = inputDomain.substr(0, tldIndex - 1) + "." + tld;
            return tld;
        }
    });
    if (finalDomain) {
        return finalDomain;
    } else {
        return inputDomain;
    }
}

function hideResults() {

    if (wixWindow.formFactor === "Desktop") {
        $w("#disclamer").show();
    }
    $w("#xIcon").hide();
    $w("#preloader").hide();
    $w("#greenXIcon").hide();
    $w("#errorText").collapse();
    // $w('#disclamer').show();//here

    // $w('#repeaterMsg').expand()

    $w("#getINow").hide();
    $w("#searchDomain").show();
    $w("#mainSearchInput").style.borderColor = "#323232";
    $w("#mainSearchInput").style.color = "#323232";
    $w("#loadMore").collapse();
}

function voucherIncluded(domain) {
    let found = false;
    let voucherTlds = [
        ".com",
        ".net",
        ".org",
        ".info",
        ".biz",
        ".rocks",
        ".pictures",
        ".club",
        " .space",
        ".shop",
        ".store",
        ".online",
        " .co.uk",
        ".xyz",
        ".art",
        ".de",
        ".com.br",
    ];
    voucherTlds.forEach((tld) => {
        if (domain.endsWith(tld)) {
            found = true;
        }
    });
    return found;
}

function isDomainAvailabile(suggestions = [], inputDomain = '') {
    const inputDomainIndex = suggestions.findIndex(suggestion => suggestion.domain === inputDomain);
    if (inputDomainIndex === -1) {
        return false;
    }
    let domain;
    //let  price;
    $w('#searchDomain').hide();
    $w('#getINow').show();
    startTimeView = new Date();
    $w('#mainSearchInput').style.borderColor = '#098961';
    $w('#mainSearchInput').style.color = '#098961';
    $w('#xIcon').hide();
    $w('#greenXIcon').show();
    $w('#preloader').hide();

    if (inputDomain.split('.').length > 2) { domain = `${inputDomain.split('.')[1]}.${inputDomain.split('.')[2]}` } else { domain = inputDomain.split('.')[1] }
    // price = prices[domain];
    wixWindow.formFactor === 'Desktop' ? $w("#errorText").text = `Good news! ${inputDomain} can be yours right now.` :
        $w("#errorText").text = `Good news! ${inputDomain} can be yours right now.`

    $w("#errorText").expand();
    $w('#getINow').onClick(() => {
        getDomain({ price: ''/*`${price}/year`*/, domainName: inputDomain, position: 0, type: "available" })
    })
    return true;
}